

import barba from '@barba/core';
import StickySidebar from 'sticky-sidebar'


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        });
        barba.hooks.after((data) => {
            this.init()
        });

    }
    init(){
        const sidebar = document.querySelector("#l-side")
        if(sidebar){
            window.Sidebar = new StickySidebar('#l-side', {
                containerSelector: '.js-sticky__wrapper',
                innerWrapperSelector: '.js-sticky__side',
                topSpacing: 115,
            })
            
            this.is_tablet()
            window.addEventListener("resize",() => {
                this.is_tablet()
            })

            window.addEventListener("scroll",() => {
                if(window.outerWidth < 992){
                    return
                }
                const srollVal = document.body.scrollTop + 1

                this.getRects()
                const actives = document.querySelectorAll("[data-observer-links].-active")
                actives.forEach((a) => {
                    a.classList.remove("-active")
                })
                this.targets.forEach((t) => {
                    if (srollVal > (t.top) && srollVal < (t.bottom)) {
                        
                        t.link.classList.add("-active")
                    }
                })
                
            })
        }
     
    }
    is_tablet(){
        if(window.outerWidth < 992){
            window.Sidebar.destroy()
            
        }else{
            window.Sidebar.initialize()
        }
        
    }
    getRects(){
        if(window.outerWidth < 992){
            return
        }
        const links = document.querySelectorAll('[data-observer-links]')
        this.targets = []
        const header = document.querySelector("#l-header")
        this.headerHeight = header.clientHeight

        links.forEach((link) => {
            const target = document.querySelector(link.getAttribute('href'))
            if(target){
                this.targets.push({
                    "link": link,
                    "top":target.getBoundingClientRect().top + document.body.scrollTop - this.headerHeight,
                    "bottom":target.getBoundingClientRect().bottom + document.body.scrollTop - this.headerHeight,
                })   
            }
        })
    }
}